/* ===================================================================
   樂誠 2026-10-05
   給「自繪商品卡」用的加入購物車（搭配 snippets/lgw-atc-button.liquid）

   為什麼要自己寫：
     主題內建的 quick-add JS 只在主題自己的 section class 內初始化
     （theme.js 的 ProductItem(container) 是由 CollectionSection / SearchSection
     之類的 class 呼叫），第三方 section ss-featured-collection-tabs-2 自己刻卡片，
     拿不到那套 JS。所以這裡用最標準的 Cart AJAX API 自己處理。

   安全性：
     - 只攔截帶 data-lgw-atc 的按鈕（＝我們自己 render 的），不影響主題任何按鈕
     - 事件用 document 委派，section 重新渲染（換分類頁籤）也照樣有效
     - 重複載入無害（有 window.__lgwAtcInit 守衛）
   =================================================================== */
(function () {
  if (window.__lgwAtcInit) return;
  window.__lgwAtcInit = true;

  var ADDING_TEXT = '加入中…';
  var ADDED_TEXT = '已加入 ✓';
  var FAIL_TEXT = '加入失敗，請重試';

  function setLabel(btn, text) {
    var label = btn.querySelector('.lgw-atc__label');
    if (label) label.textContent = text;
  }

  function currentLabel(btn) {
    var label = btn.querySelector('.lgw-atc__label');
    return label ? label.textContent : '';
  }

  // 更新頁首購物車數量（主題用 [data-header-cart] + .header__cart-link-count）
  function updateHeaderCartCount(count) {
    var links = document.querySelectorAll('[data-header-cart]');
    Array.prototype.forEach.call(links, function (link) {
      link.setAttribute('data-cart-count', count);
      var badge = link.querySelector('.header__cart-link-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'header__cart-link-count';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.textContent = '';
      }
    });
  }

  /* ------------------------------------------------------------------
     加購的共用邏輯（click 與 submit 兩條路都呼叫它）
     2026-10-06：按鈕改成「真表單 + JS 攔截」的漸進增強。
       - 有 JS：click / 表單 submit 都會被攔下來走 AJAX（不跳頁、有綠回饋）
       - 沒 JS（lgw-atc.js 掉檔）：攔截不存在，瀏覽器原生 POST /cart/add → 商品照樣進購物車
     ------------------------------------------------------------------ */
  function handleAdd(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    if (btn.dataset.lgwBusy === '1') return;

    btn.dataset.lgwBusy = '1';
    var original = currentLabel(btn);
    setLabel(btn, ADDING_TEXT);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateHeaderCartCount(cart.item_count);
        }
        btn.classList.add('is-added');
        setLabel(btn, ADDED_TEXT);
        setTimeout(function () {
          btn.classList.remove('is-added');
          setLabel(btn, original);
          btn.dataset.lgwBusy = '0';
        }, 2000);
      })
      .catch(function () {
        setLabel(btn, FAIL_TEXT);
        setTimeout(function () {
          setLabel(btn, original);
          btn.dataset.lgwBusy = '0';
        }, 2500);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-lgw-atc]') : null;
    if (!btn) return;

    // 有 JS 時不要讓表單真的送出（否則會跳頁）；改走 AJAX
    e.preventDefault();
    handleAdd(btn);
  });

  /* 鍵盤 Enter 送出表單時（沒有 click 事件）也要攔下來走 AJAX */
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-lgw-atc-form]') : null;
    if (!form) return;

    e.preventDefault();
    var btn = form.querySelector('[data-lgw-atc]');
    if (btn) handleAdd(btn);
  });

  /* ------------------------------------------------------------------
     「售罄」點一下閃紅（客戶 2026-10-05 要求）
     它本來就加不了購物車，但客人還是會去按；給一個明確回饋比沒反應好。
     兩種卡片（自繪卡 lgw-atc-button / 主題卡 product-item）共用同一個 class，
     所以這裡用 document 委派，一次蓋掉全部。
     ------------------------------------------------------------------ */
  var SOLD_FLASH_MS = 1300;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.lgw-soldout-btn') : null;
    if (!btn) return;

    e.preventDefault();
    if (btn.dataset.lgwSoldFlash === '1') return;

    btn.dataset.lgwSoldFlash = '1';
    btn.classList.add('is-tapped');
    setTimeout(function () {
      btn.classList.remove('is-tapped');
      btn.dataset.lgwSoldFlash = '0';
    }, SOLD_FLASH_MS);
  });
})();
